export default __webpack_public_path__ + "static/media/DBPrestamo.185056a0.svg";